import { DotsLoader } from "@similarweb/ui-components";

import { StyledDotsLoaderWrapper } from "app/pages/sales-intelligence/common-components/SIDotsLoader/styles";

const SIDotsLoader = () => {
    return (
        <StyledDotsLoaderWrapper>
            <DotsLoader />
        </StyledDotsLoaderWrapper>
    );
};

export default SIDotsLoader;
